{% block hueb_seo_rich %}
    <div v-if="richSnippets">

        <sw-inherit-wrapper v-model:value="richSnippets.itemCondition"
                            :hasParent="!!parentRichSnippets.id"
                            :label="$tc('hueb-seo.card.rich.labelItemCondition')"
                            :helpText="$tc('hueb-seo.card.rich.helpRichSnippets')"
                            :inheritedValue="parentRichSnippets.itemCondition">
            <template #content="{ currentValue, updateCurrentValue, isInherited }">

                <mt-select
                    :disabled="!active || isInherited"
                    v-model="currentValue"
                    @update:model-value="updateCurrentValue"
                    :options="optionsItemCondition">
                </mt-select>

            </template>
        </sw-inherit-wrapper>


        <sw-inherit-wrapper v-model:value="richSnippets.availability"
                            :hasParent="!!parentRichSnippets.id"
                            :label="$tc('hueb-seo.card.rich.labelAvailability')"
                            :inheritedValue="parentRichSnippets.availability">
            <template #content="{ currentValue, updateCurrentValue, isInherited }">

                <mt-select
                    :disabled="!active || isInherited"
                    v-model="currentValue"
                    @update:model-value="updateCurrentValue"
                    :options="optionsAvailability">
                </mt-select>

            </template>
        </sw-inherit-wrapper>


        <sw-inherit-wrapper v-model:value="richSnippets.mpn"
                            :hasParent="!!parentRichSnippets.id"
                            :inheritedValue="parentRichSnippets.mpn">
            <template #content="props">
                <mt-text-field
                    :mapInheritance="props"
                    :disabled="!active || props.isInherited"
                    :helpText="$tc('hueb-seo.card.rich.helpRichSnippetsEmpty')"
                    :label="$tc('hueb-seo.card.rich.labelMPN')"
                    :placeholder="$tc('hueb-seo.card.rich.placeholderDefault')"
                    v-model="props.currentValue"
                    @update:value="props.updateCurrentValue"></mt-text-field>

            </template>
        </sw-inherit-wrapper>


        <sw-inherit-wrapper v-model:value="richSnippets.sku"
                            :hasParent="!!parentRichSnippets.id"
                            :inheritedValue="parentRichSnippets.sku">
            <template #content="props">

                <mt-text-field
                    :mapInheritance="props"
                    :disabled="!active || props.isInherited"
                    :helpText="$tc('hueb-seo.card.rich.helpRichSnippetsEmpty')"
                    :label="$tc('hueb-seo.card.rich.labelSKU')"
                    :placeholder="$tc('hueb-seo.card.rich.placeholderDefault')"
                    v-model="props.currentValue"
                    @update:value="props.updateCurrentValue">
                </mt-text-field>

            </template>
        </sw-inherit-wrapper>


        <sw-inherit-wrapper v-model:value="richSnippets.priceValidUntil"
                            :hasParent="!!parentRichSnippets.id"
                            :label="$tc('hueb-seo.card.rich.labelPriceValidUntil')"
                            :helpText="$tc('hueb-seo.card.rich.helpRichSnippetsEmpty')"
                            :inheritedValue="parentRichSnippets.priceValidUntil">
            <template #content="{ currentValue, updateCurrentValue, isInherited }">

                <sw-datepicker
                    :disabled="!active || isInherited"
                    :value="currentValue"
                    @input="updateCurrentValue">
                </sw-datepicker>

            </template>
        </sw-inherit-wrapper>

    </div>
{% endblock %}
